import React from 'react';
import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl';
import { LocaleProvider } from 'antd'
import ru from 'antd/lib/locale-provider/ru_RU';
import en from 'antd/lib/locale-provider/en_US';
import messages from 'messages';

const antLocales = {
  ru,
  en,
};

class IntlProviderWrapper extends React.Component {
  render() {
    const { locale } = this.props;

    return (
      <IntlProvider {...this.props}>
          <LocaleProvider locale={antLocales[locale]}>
            {this.props.children}
          </LocaleProvider>
      </IntlProvider>
    );
  }
}

const mapStateToProps = state => {
  const locale = state.getIn(['app', 'locale']);

  return {
    messages: messages[locale],
    locale,
  }
};

export default connect(mapStateToProps)(IntlProviderWrapper);


// WEBPACK FOOTER //
// ./src/IntlProvider.js